import React from 'react'
import AdminNavbar from '../Componet/AdminNavbar'
import TiffinManagementSystem from '../Componet/TiffinManagementSystem1'
import Footer from '../Componet/Footer'

//import TiffinManagementSystem from "./tiffin_rec";

function AdminAtt() {
  return (
    <div>
        <AdminNavbar/>
        <TiffinManagementSystem/>
          <Footer/>
      
    </div>
  )
}

export default AdminAtt
